import React, { useState, useContext, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
// import { PDFDocument, PDFField, PDFForm } from 'pdf-lib';
import samplePdf from './SD_Scorecard.pdf'; // replace with your PDF file
import type { PDFPageProxy, PDFDocumentProxy } from 'pdfjs-dist';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import './ScoreCardEntry.css';
// import { AnyObject } from 'final-form';
import {
    PDFDocument,
    PDFForm,
    PDFField,
    PDFPage,
    StandardFonts,
    rgb
} from 'pdf-lib';
  
type FieldInfo = {
    name: string;
    type: string;
    pageIndex: number;
    rect: { x: number; y: number; width: number; height: number };
};

// Required for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfFormFiller = () => {
  const [pdfPageSize, setPdfPageSize] = useState({ width: 0, height: 0 });
  const [inputValues, setInputValues] = useState<{ [key: string]: string }>({});
  const [pdfForm, setPdfForm] = useState<PDFForm | null>(null);
  const [pdfDocument, setPdfDocument] = useState<PDFDocument | null>(null);
  // const [fields, setFields] = useState<Array<PDFField> | null>(null);
  const [htmlFields, setHtmlFields] = useState<Array<{
    name: string;
    type: string;
    pageIndex: number;
    top: number;
    left: number;
    width: number;
    height: number;
  }> | null>(null);  
  const [numPdfPages, setNumPdfPages] = useState(null);
  // const [inputValue, setInputValue] = useState('');  
  const [renderedHeight, setRenderedHeight] = useState<number>(0);
  const [pdfBytes, setPdfBytes] = useState(null);
  const renderWidth = 1000;
  const viewerRef = useRef<HTMLDivElement | null>(null);
  const pdfPageRef = useRef<HTMLDivElement | null>(null);
  const appContext = useContext<IAppContextState>(AppContext);

  useEffect(() => {
    // Load original PDF as bytes for later saving
    if (!numPdfPages) {
        setNumPdfPages(0);
    }
    fetch(samplePdf)
      .then((res) => res.arrayBuffer())
      .then(setPdfBytes);
  }, []);

  useEffect(() => {
    if (!!pdfBytes) {
        // listFormFields(pdfBytes);
        loadPdfDocument();
        console.log(appContext.currentUser.username);
    }
  }, [pdfBytes]);

  useEffect(() => {
    if (!!pdfForm) {
        setHtmlFields(getHtmlFields());
    }
  }, [pdfForm]);

  useEffect(() => {
    if (!!pdfDocument) {
        setPdfForm(pdfDocument.getForm());
    }
  }, [pdfDocument]);

  useEffect(() => {
    if (pdfPageRef.current) {
      const height = pdfPageRef.current.clientHeight;
      setRenderedHeight(height);
    }
  }, [pdfPageRef]);

  useEffect(() => {
    if (htmlFields && htmlFields.length > 0) {
      // Find the "Employee Name" field
      const employeeField = htmlFields.find(f => f.name === 'Employee Name');
      if (employeeField) {
        setInputValues(prev => ({
          ...prev,
          [employeeField.name]: appContext.currentUser.username || ''
        }));
      }

      const hireDateField = htmlFields.find(f => f.name === 'Hire Date');
      if (hireDateField) {
        setInputValues(prev => ({
          ...prev,
          [hireDateField.name]: new Date().toLocaleDateString() || ''
        }));
      }
    }
  }, [htmlFields, appContext.currentUser.username]);  

  const onDocumentLoadSuccess = (pdf: PDFDocumentProxy) => {
    pdf.getPage(1).then((page: PDFPageProxy) => {
      const viewport = page.getViewport({ scale: 1 });
      setPdfPageSize({ width: viewport.width, height: viewport.height });
    });
  };

  const handlePageRenderSuccess = () => {
    if (viewerRef.current) {
      const canvas = viewerRef.current.querySelector('canvas');
      if (canvas) {
        setRenderedHeight(canvas.offsetHeight);
      }
    }
  };

  const loadPdfDocument = async () => {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    setPdfDocument(pdfDoc);
  };

  const saveFilledPDF = async () => {
    if (!pdfBytes || !htmlFields) {
      return;
    }
  
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const form = pdfDoc.getForm();
    const pages = pdfDoc.getPages();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  
    htmlFields.forEach(field => {
      const value = inputValues[field.name] || '';
  
      try {
        // If a real AcroForm text field exists, set its value
        const pdfField = form.getTextField(field.name);
        pdfField.setText(value);
      } catch {
        // If no real PDF field exists, draw text manually
        const page = pages[field.pageIndex || 0];
        page.drawText(value, {
          x: field.left,
          y: field.top,
          size: 12,
          font,
          color: rgb(0, 0, 0),
          maxWidth: field.width,
          lineHeight: field.height,
        });
      }
    });
  
    const filledPdfBytes = await pdfDoc.save();
    const blob = new Blob([filledPdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'filled.pdf';
    link.click();
  };
  
/*
  const listFormFields = async (bytesFromPdf: ArrayBuffer) => {
    const pdfDoc = await PDFDocument.load(bytesFromPdf);
    const form = pdfDoc.getForm();
    const pdfFields = form.getFields();
    setFields(pdfFields);
  };

  const displayFormFields = () => {
    return (fields?.map((field, index) => (
        <div key={field.getName() + index}>
          Field name: {field.getName()}, type: {field.constructor.name}
        </div>
      )));
  };

   const getHtmlFields = () => {
    const page = pdfDocument.getPages()[0];
    const { height: pageHeight } = page.getSize();

    const pdfFields = getFieldsInfo();
    if (!!pdfFields) {
        const localHtmlFields = pdfFields?.map(field => {
        if (!field.rect) {
            return null;
        }

        const [x1, y1, x2, y2] = field.rect;
        const width = x2 - x1;
        const height = y2 - y1;

        return {
                name: field.name,
                type: field.type,
                top: pageHeight - y2,  // Flip Y axis
                left: x1,
                width,
                height,
            };
        });
        return localHtmlFields;
    } else {
        return ([{
            name: '', 
            type: '',
            top: 0,
            left: 0,
            width: 0,
            height: 0
        }]);
    }
  }; */

  const getHtmlFields = () => {
    const pages = pdfDocument.getPages();
    const pdfFields = getFieldsInfo();
  
    if (!pdfFields || !pages.length) {
        return [];
    }
  
    const localHtmlFields = pdfFields.map((field) => {
      if (!field.rect || typeof 0 !== 'number') {
        return null;
      }
  
      const { x, y, width, height } = field.rect;
      const page = pages[0];
      const pageHeight = page.getSize().height;
  
      return {
        name: field.name,
        type: field.type,
        pageIndex: 0,
        top: pageHeight - y - height, // Flip PDF Y-axis to HTML Y-axis
        left: x,
        width,
        height,
      };
    });
  
    return localHtmlFields.filter(Boolean);
  };
  
  interface IPdfWidget {
    getRectangle: () => { x: number; y: number; width: number; height: number };
    P: () => unknown;
  }
  
  const getFieldsInfo = (): FieldInfo[] => {
    const pages = pdfDocument.getPages();
    const pdfFields = pdfForm.getFields();
  
    const fieldEntries = pdfFields.map((field: PDFField) => {
      const name = field.getName();
      const type = field.constructor.name;
  
      const acroField = (field as unknown as { acroField: { getWidgets: () => IPdfWidget[] } }).acroField;
      const widgets = acroField?.getWidgets?.() || [];
  
      return widgets.map((widget) => {
        const rect = widget.getRectangle();
        const pageRef = widget.P();
        const pageIndex = pages.findIndex((page: PDFPage) => page.ref === pageRef);
  
        if (!rect) {
          return null;
        }
  
        if (pageIndex === -1 || pageIndex > 0) {
          return null;
        }
  
        const { x, y, width, height } = rect;
  
        return {
          name,
          type,
          pageIndex,
          rect: { x, y, width, height },
        };
      });
    });
  
    return ([] as FieldInfo[]).concat(...fieldEntries).filter((f): f is FieldInfo => f !== null);
  };
  
/*   const getFieldsInfo = () => {
  const fieldsInfo = pdfForm.getFields().map((field) => {
    const name = field.getName();
    const type = field.constructor.name;
  
    // Get the widget(s) for the field
    const widgets = (field as AnyObject).acroField?.getWidgets?.();
    if (!widgets || widgets.length === 0) {
        return null;
    }
  
    const widget = widgets[0];
  
    // Get the rectangle: [x1, y1, x2, y2]
    const rect = widget.getRectangle();
  
    return {
      name,
      type,
      rect,
    };
  }).filter(Boolean);

  return fieldsInfo;
}; */

  return (
    <div ref={pdfPageRef}>
        {/*<div>
            {fields && displayFormFields()}
        </div>*/}
      <div className="pdf-wrapper">
        <div style={{ position: 'relative' }} ref={viewerRef}>
          <Document file={samplePdf} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={1} width={renderWidth} onRenderSuccess={handlePageRenderSuccess} />
          </Document>
          {htmlFields && htmlFields.map((field) => {
            const scaleX = renderWidth / pdfPageSize.width;
            const scaleY = renderedHeight / pdfPageSize.height;
            // const NAVBAR_HEIGHT = !! viewerRef?.current ? viewerRef?.current?.getBoundingClientRect().top : 0;

            return (
              <input
                key={field.name}
                type="text"
                name={field.name}
                style={{
                  position: 'absolute',
                  top: `${field.top * scaleY}px`,
                  left: `${field.left * scaleX}px`,
                  width: `${field.width * scaleX}px`,
                  height: `${field.height * scaleY}px`,
                  fontSize: '12px',
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  border: '1px solid gray',
                }}
                value={inputValues[field.name] || ''}
                onChange={(e) =>
                  setInputValues(prev => ({ ...prev, [field.name]: e.currentTarget.value }))
                }
              />
            );
          })}
          {/* Editable Input Overlay 
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            style={{
              position: 'absolute',
              top: '150px', // adjust as needed
              left: '150px', // adjust as needed
              width: '200px',
              height: '20px',
              fontSize: '14px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              border: '1px solid gray',
            }}
          />*/}
        </div>
      </div>
      <button
        onClick={saveFilledPDF}
        style={{
          border: '1px solid black',
          marginTop: '20px',
          width: 'auto',
          display: 'inline-block',
          flex: '0 0 auto', // prevents flexbox parents from stretching it
          padding: '0.5rem 1rem', // optional, for nicer spacing
          cursor: 'pointer'
        }}
      >
        Save Filled PDF
      </button>
    </div>
  );
};

export default PdfFormFiller;


// WEBPACK FOOTER //
// ./src/components/personnel/components/ScoreCardEntry.tsx